const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
  },
  {
    languageId: 'vietnam',
    locale: 'vi',
    name: 'Việt Nam',
  },
];
export default languageData;
